export default __webpack_public_path__ + "static/media/audio@2x.dd0ed6a3.png";